import * as React from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { MenuScreenSectionView } from './MenuScreenSectionView';
import { MenuScreenView } from './MenuScreenView/MenuScreenView';

export const MenuManagementSwitch: React.FC<RouteComponentProps<{
  id?: string;
}>> = ({ match: { url, path } }) => (
  <React.Fragment>
    <BreadcrumbsItem to={url}>Screens</BreadcrumbsItem>

    <Switch>
      <Route exact path={path}>
        <MenuScreenView />
      </Route>

      <Route path={`${path}/:id([0-9]+)/sections`}>
        <MenuScreenSectionView />
      </Route>

      <Route>
        <Redirect to={path} />
      </Route>
    </Switch>
  </React.Fragment>
);
